module.exports = {"id":"138810","name":"Alejandro Domínguez","rating":"76","photo":"./data/images/photos/4/138810.png","club":{"name":"Rayo Vallecano","logo":"./data/images/clubs/RayoVallecano.png"},"positions":["MOC","BU","MC"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/AlejandroDominguez0.json
// module id = 180
// module chunks = 0